export const homeFaqs = [
  {
    q: "Who provides keepsake portrait photography near me in San Antonio?",
    a: "Precious Keepsakes Photography, led by Stephanie, is San Antonio&apos;s premier keepsake portrait studio. With 15+ years creating heirloom-quality imagery — from newborns to weddings — families across San Antonio trust Stephanie to preserve their most sacred moments as timeless keepsakes.",
  },
  {
    q: "How much does keepsake photography cost in San Antonio?",
    a: "Investment varies by session type and product selections. Precious Keepsakes offers fully custom packages designed around your vision. Clients regularly note the value far exceeds expectations — high-end keepsake quality at accessible prices. Contact us for a personalized quote.",
  },
  {
    q: "How long does a keepsake photography session take?",
    a: "Newborn sessions run 2–4 hours to ensure a relaxed, unhurried experience for baby and family. Wedding coverage varies by package. Milestone and portrait sessions typically run 1–2 hours. Stephanie never rushes — your comfort and your images always come first.",
  },
  {
    q: "What keepsake products does Precious Keepsakes Photography offer?",
    a: "Beyond your private digital gallery, Precious Keepsakes offers fine art prints, canvas wraps, heirloom albums, framed wall art, and custom keepsake collections — all produced at museum-quality to be displayed and passed down for generations.",
  },
  {
    q: "How far in advance should I book a keepsake photography session?",
    a: "Newborn sessions should be booked in your second trimester to secure your due date window. Wedding photography is recommended 6–12 months in advance. Milestone and portrait sessions can typically be arranged with 2–4 weeks&apos; notice.",
  },
  {
    q: "What makes Precious Keepsakes Photography different from other San Antonio photographers?",
    a: "Stephanie&apos;s philosophy is rooted in genuine connection and intentional storytelling. Each session produces images that feel authentic, emotional, and worth preserving forever. Combined with 15+ years of expertise, custom packages, and heirloom product offerings — the experience is truly elevated.",
  },
];

export const servicesFaqs = [
  {
    q: "What is included in a luxury wedding photography package?",
    a: "Packages are fully customized and can include full-day coverage, a second shooter, engagement sessions, and fine art albums. Stephanie works with you to design a package that honors every aspect of your day.",
  },
  {
    q: "How long does it take to receive keepsake wedding photos?",
    a: "Edited wedding galleries are typically delivered within 4–6 weeks. Newborn and portrait sessions are usually returned within 2–3 weeks. Every image is meticulously edited to the studio's fine art aesthetic.",
  },
  {
    q: "Can I bring my own outfits to a newborn keepsake session?",
    a: "Absolutely. You&apos;re welcome to bring your own outfits and props, or use Stephanie&apos;s curated wardrobe collection. Many families do a combination of both for variety and a more personal keepsake gallery.",
  },
  {
    q: "Do you offer maternity and newborn keepsake bundle packages?",
    a: "Yes. Maternity and newborn bundle packages are available and offer significant value. Booking both sessions together also allows Stephanie to maintain consistent styling and tone across both keepsake galleries.",
  },
];

export const aboutFaqs = [
  {
    q: "How long has Stephanie been creating keepsake photography in San Antonio?",
    a: "Stephanie has been capturing once-in-a-lifetime memories for 15+ years. Based in San Antonio, Texas, she has built a reputation as one of the city&apos;s most trusted luxury keepsake portrait and wedding photographers.",
  },
  {
    q: "Is Precious Keepsakes Photography a studio or on-location?",
    a: "Both. Precious Keepsakes offers in-studio sessions as well as on-location shoots throughout San Antonio and the surrounding Hill Country region. Stephanie brings her full professional setup wherever you need her.",
  },
  {
    q: "What is Stephanie&apos;s approach to newborn keepsake photography?",
    a: "Safety and connection come first. Stephanie creates a warm, calm environment where both baby and parents feel at ease. Her patient approach means sessions are never rushed — she takes the time needed to capture truly meaningful keepsake images.",
  },
  {
    q: "Does Stephanie only do newborn and wedding photography?",
    a: "No — while newborns and weddings are her signature keepsake specialties, Stephanie also photographs maternity, seniors, quinceañeras, sweet sixteens, and milestone family sessions. Every chapter of your story is worth preserving.",
  },
];

export const locationFaqs = [
  {
    q: "Does Precious Keepsakes Photography serve areas outside San Antonio?",
    a: "Yes. Stephanie serves clients across the greater San Antonio metro area including Boerne, New Braunfels, Schertz, Converse, Universal City, and the Texas Hill Country. Travel fees may apply for sessions beyond a set radius.",
  },
  {
    q: "Can I meet with Stephanie before booking a keepsake session in San Antonio?",
    a: "Yes, consultations are available. Stephanie welcomes the opportunity to connect before the session to discuss vision, wardrobe, location, and any questions — so your keepsake session is perfectly planned.",
  },
  {
    q: "How far does the San Antonio keepsake photographer travel for weddings?",
    a: "Stephanie is available for weddings throughout Texas and is open to destination wedding inquiries. Her primary coverage area includes San Antonio, the Texas Hill Country, Austin, and surrounding regions.",
  },
  {
    q: "Is there a studio location I can visit in San Antonio?",
    a: "Precious Keepsakes Photography is based in San Antonio, Texas. Session locations are arranged during your consultation based on your vision — whether that means Stephanie&apos;s studio, your home, or a scenic outdoor location.",
  },
];
